import React from "react";
import { OrderedMap } from "immutable";
import { Row, Col, Card, Button, message, Modal, Descriptions, Input, InputNumber } from "antd";
import PropTypes from "prop-types";
import { Table } from "components";
import { COMPANY_ASSESSMENT_COLS, ASSESSMENT_CAM_DETAILS_COLS } from "constants/table-columns";
import CaseService from "services/case-service";
import CompanyService from "../../services/company-service";
import { formatCurrency } from "../../utils";

const onCellGenerator = (handleSave, _) => record => ({
    record,
    editable: record.deviation === "Yes" || (record.deviation === "No" && record.remarks !== "--" && (record.remarks !== null || record.remarks.length >= 0)) ? true : false,
    dataIndex: _.dataIndex,
    title: record.header || _.title,
    handleSave,
    rules: record.rules || _.rules,
    fieldType: record.fieldType || _.fieldType,
    filesMultiple: _.filesMultiple ? _.filesMultiple : false,
    options: record.options || _.options,
    getFileUploadParams: _.getFileUploadParams,
    uploadTarget: _.uploadTarget,
    viewable: _.viewable,
    max: record.max
});

class CompanyAssessmentReviewReport extends React.Component {
    state = {
        originalResponse: {},
        newData: new OrderedMap({}),
        loading: false,
		d2rUtilisationData : {},
		approvedLimit : null
    };

    componentDidMount() {
		this.getD2RLimitDetails();
		CompanyService.companyPostCibilParameter(this.props.companyId).then(_ => {
			CompanyService.getComapnyCreditAssessment(this.props.companyId).then(res => {
				this.setState({
					originalResponse: res.data,
					newData: res.data && new OrderedMap(res.data.data),
				});
			}).catch(() => {});
		}).catch(err => {
			console.log("err", err);
		})
    }

    updateDetails = () => {
        let data = {
            ...this.state.originalResponse,
            data: this.state.newData && this.state.newData.toJS()
        };            
		CompanyService.updateCompanyCreditAssessment(this.props.companyId, data).then(() => {
			message.success("Assessment Report Updated");
		}).catch(() => {
			message.error("Failed to update Assessment Report");
		}); 
    }

    handleSaveMultipleEntries = (record, values) => {
        if(record.key && this.state.newData.size) {
            let data = this.state.newData.map((_, k) => {
                if(k == record.key) {
                    return {
                        ..._,
                        ...values,
                        key: record.key
                    };
                }
                return _;
            });
            this.setState({
                newData: data
            });
        }
    }

    refreshDetails = () => {
		CompanyService.refreshCompanyCreditAssessmentData(this.props.companyId).then((res) => {
			this.setState({
				originalResponse: res.data,
				newData: res.data && new OrderedMap(res.data.data),
				loading: false
			});
		}).catch(() => {});
    }

    loadTable = () => {
        this.setState({
            loading: true,
            originalResponse: {},
            newData: new OrderedMap({}),
        }, () => this.refreshDetails());
    }

	getD2RLimitDetails = () => {
		CompanyService.getD2RLimitUtilisation(this.props.companyId)
			.then((_) => {
				this.setState({d2rUtilisationData : _.data.d2r_history})
			})
	}

	updateApproveLimit =  () => {
		CompanyService.updateD2RLimitUtilisation(this.props.companyId , this.state.approvedLimit)
		.then((_) => {
			message.success("Limit Updated Successfully");
			this.getD2RLimitDetails();
		}).catch(err => {
			if (err &&err.non_field_errors) {
				message.error(Object.values(err)[0]);
			} else {
				message.error("Something went wrong!");
			
			}		
		})
	}

    updateGstFiling =  () => {
		CompanyService.refreshCompanyGstinFillingDetails(this.props.profile.getIn(["data", "gstin"]))
		.then((_) => {
			message.success("Updated Successfully");
			this.getD2RLimitDetails();
		}).catch(err => {
			if (err &&err.non_field_errors) {
				message.error(Object.values(err)[0]);
			} else {
				message.error("Something went wrong!");
			
			}		
		})
	}

    render() {

        const bankCodeCIFCL = ["CIFCL", "MF"].includes(this.props.caseDetail?.bank?.code);
        let supplyChainAnchorZetwerk = this.props.caseDetail?.supply_chains.find(el=>el.anchor.name === "Zetwerk Manufacturing Businesses Private Limited" || el.anchor.name ==="Hella Infra Market Private Limited");
        const cifcl_data_labels = ["Tranche Tenure", "Limit Tenure", "Co-Applicant", "Constitution of Customer", "RC Facility Amt. Sanction Amt.", "CMR/MSME rank greater than 8 (Commercial Cibil)", "Written-off, Suit filed, Settled, Willful defaulter within last 2 years (excluding CC)(Commercial Cibil)", "SMA 2 in last 6 months (CC)(Commercial Cibil)"];
        const cifcl_render_data = this.state.newData.filter(_=> cifcl_data_labels.includes(_?.label) && _.visible);
        const render_data = bankCodeCIFCL && supplyChainAnchorZetwerk !== undefined ? cifcl_render_data : this.state.newData.filter(_ => _ && _.visible);
		let data = render_data.toList().sortBy(__ => __.sno).groupBy(_ => _.d2r_limit_range).map(values => values.unshift({
			title : values.getIn([0 , 'd2r_limit_range'])
		})).toList().flatten();

		
        return (
            <React.Fragment>
                <Row className={"p-10"}>
					<Col span={24}>
						
						<Descriptions>
							<Descriptions.Item label="Eligible Slab">{this.state.d2rUtilisationData['eligible_slab'] || '--'}</Descriptions.Item>
							<Descriptions.Item
								label="Credit Approved Limit">
								<InputNumber
									onChange={(e) => this.setState({
										approvedLimit: e
									})}
									disabled={!this.state.d2rUtilisationData['credit_approved_limit']}
									value={this.state.approvedLimit ? this.state.approvedLimit : this.state.d2rUtilisationData['credit_approved_limit']}
								/>
                                    {Object.keys(this.state.d2rUtilisationData).length ? <Button type="link" className="float-right" onClick={() => this.updateApproveLimit()}>Update</Button> : null}
                                </Descriptions.Item>
							<Descriptions.Item label="GST Filing Date">{this.state.d2rUtilisationData['gst_filing_date'] || '--'} {"  "} <Button type="link" className="float-right" onClick={() => this.updateGstFiling()}>Update</Button></Descriptions.Item>
						</Descriptions>
						<Descriptions>
							<Descriptions.Item label="D2R Limit Approved Under DB">{formatCurrency(this.state.d2rUtilisationData['credit_approved_limit'])}</Descriptions.Item>
							<Descriptions.Item label="Limit Utilized">{formatCurrency(this.state.d2rUtilisationData['d2r_utilized_limit'])}</Descriptions.Item>
							<Descriptions.Item label="Limit Available">{formatCurrency(this.state.d2rUtilisationData['d2r_limit_available'])}</Descriptions.Item>
						</Descriptions>

					</Col>
                    <Col span={24}>
                        <Card title={"Credit Assessment Review"} className={"padless-card"} extra={[
                            <Button type={"link"} onClick={this.loadTable} key="refresh">
                                Refresh
                            </Button>,
                            <Button type={"link"} onClick={this.updateDetails} key="update"
                                disabled={this.props.recreditViewOnlyPermission}
                            >
                                Update 
                            </Button>
                        ]}>
                            <Table
                                columns={COMPANY_ASSESSMENT_COLS.map(({ editable, ...restColFields}) => {
                                    if (!onCellGenerator || !editable) {
                                        return { ...restColFields };
                                    }
                                    return {
                                        onCell: onCellGenerator(
                                            this.handleSaveMultipleEntries,
                                            restColFields
                                        ),
                                        ...restColFields
                                    };
                                })}
                                loading={this.state.loading}
                                data={data.map((_, k) => {
                                    let row = _;
									if(_.title != null){
                                        row.key = k;
										row.label = <span className={this.state.d2rUtilisationData['eligible_slab'] == _.title ? "text-highlight text-green" : "text-highlight text-red"} >Limit Range :  {_.title}</span>,
                                        row.sno = '';
                                        row.value = this.state.d2rUtilisationData['eligible_slab'] == _.title ? 'Applicable' : 'Not Applicable';
                                        row.review_category = null;
                                        row.remarks = '';
										return row;
									}else if(row && typeof row === "object") {
                                        row.key = k;
                                        row.sno = _.sno;
                                        row.value = _.value;
                                        row.review_category = _.deviation === "No" ? _.review_category || "OK" : _.review_category;
                                        row.remarks = _.deviation === "No"  ? _.remarks || "--" : _.remarks;
                                    }
                                    return row;
                                })}
                                showTopSection={false}
                                editable={true}
                                noRowSelection={true}
                                pagination={false}
                            />
                        </Card>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

}

CompanyAssessmentReviewReport.propTypes = {
    companyId: PropTypes.number,
    bank: PropTypes.string,
    caseDetail: PropTypes.object,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default (CompanyAssessmentReviewReport);